import Vue from 'vue';
import SimpleVueValidation from 'simple-vue-validator';

const Validator = SimpleVueValidation.Validator;

Vue.use(SimpleVueValidation);

export default {
    data() {
        return {
            title: '',
            poster: [],
            category: 2,
            hashtag: [],
            organize: '',
            target: '',
            content: '',
            license: '',
            evaluate: [],
            intro: [],
            is_judge: 0,
            judge: [],
            prize: 100,
            startApplyDate: '',
            endApplyDate: '',
            releaseDate: '',
            chance: 1,
            u_judge:{
                create:[],
                update:[],
                delete:[]
            }
        }
    },
    computed: {

    },

    validators: {
        title: function (value) {
            return Validator.value(value)
                .required('공모전명을 입력해주세요.')
        },
        poster: function (value) {
            return Validator.value(value)
                .required('포스터를 등록해주세요.')
        },
        category: function (value) {
            return Validator.value(value)
                .required('카테고리를 선택해주세요.')
        },
        hashtag: function (value) {
            return Validator.value(value)
                .required('해시태그를 입력해 주세요.')
        },
        organize: function (value) {
            return Validator.value(value)
                .required('주관을 입력해 주세요.')
        },
        target: function (value) {
            return Validator.value(value)
                .required('대상을 입력해 주세요.')
        },
        content: function (value) {
            return Validator.value(value)
                .required(this.$t('board_write_con'))
        },
        license: function (value) {
            return Validator.value(value)
                .required('라이선스 이용안내를 입력해 주세요.')
        },
        evaluate: function (value) {
            return Validator.value(value)
                .required('평가기준을 입력해 주세요.')
        },
        intro:  function (value)  {
            return Validator.value(value)
                .custom(() => {
                        if (value.length === 0) {
                            return '안내 첨부파일을 등록해주세요.'
                        }
                    }
                )
        },

        is_judge: function (value) {
            return Validator.value(value)
        },
        judge: function (value) {
            return Validator.value(value)
                .required('심사위원을 임명해 주세요.')
        },
        prize: function (value) {
            return Validator.value(value)
                .required('상금을 입력해 주세요.')
                .custom(()=>{
                    if(value == 0){
                        return '상금을 입력해 주세요.'
                    }
                    if(value % 100 !== 0){
                        return '밍글 입력 최소단위는 100입니다.'
                    }
                })
        },
        startApplyDate: function (value) {
            return Validator.value(value)
                .required('응모 시작기간을 입력해 주세요.')
        },
        endApplyDate: function (value) {
            return Validator.value(value)
                .required('응모 종료기간을 입력해 주세요.')
        },
        releaseDate: function (value) {
            return Validator.value(value)
                .required('발표일을 입력해 주세요.')
        },
        chance: function (value) {
            return Validator.value(value)
                .required('응모 가능수를 선택해 주세요.')
        },
        u_judge: function (value)  {
            return Validator.value(value)
                .custom(() => {
                        if (value.create.length === 0 && value.update.length === 0) {
                            return '심사위원을 임명해 주세요.'
                        }
                    }
                )
        },

    },
    methods: {}
}
